import { PORTAL_PATH } from '../../../../routes/paths';

export const MAIN_PAGE_PATH = PORTAL_PATH.WALLET;
